<template>
  <div v-if="active">
    <div class="progress">
      <div class="indeterminate"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      active: {
        default: false
      }
    },
    name: "progress-loading"
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/utils/ProgressLoading.vue